import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import FloatLabelInput from '../FloatLabelInput';
import './HVERequestForm.scss';

class WelcomeStep extends Component {
    static get propTypes() {
        return {
            onNext: PropTypes.func
        };
    }

    componentDidMount() {
        trackEvent('HomeValue', 'sellerViewedEstimateFlowIntro').withGA();
    }

    render() {
        return (
            <div className="step-content">
                <svg width="168" height="168" viewBox="0 0 168 168" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="84" cy="84" r="84" fill="#F7FAFF"/>
                    <path
                        d="M69.3248 56.8H125.6C126.449 56.8 127.263 57.1372 127.863 57.7373C128.463 58.3374 128.8 59.1514 128.8 60V108C128.8 108.849 128.463 109.663 127.863 110.263C127.263 110.863 126.449 111.2 125.6 111.2H69.3248C68.4761 111.2 67.6623 110.863 67.0624 110.262L51.3376 94.5377C50.7374 93.9377 50.4001 93.1239 50.4 92.2753V75.7248C50.4001 74.8762 50.7374 74.0624 51.3376 73.4625L67.0624 57.7376C67.6623 57.1375 68.4761 56.8002 69.3248 56.8Z"
                        fill="#3889EB"/>
                    <path d="M110.247 83.0061V98.5818H84.093V83.0061L97.1704 69.9287L110.247 83.0061Z" fill="#F7FAFF"/>
                    <path
                        d="M114.657 87.4189L97.1704 69.9287L79.6831 87.4189L76.5 84.2358L95.5803 65.1592C96.0015 64.7366 96.5735 64.5 97.1704 64.5C97.7666 64.5 98.3386 64.7366 98.7598 65.1592L117.84 84.2358L114.657 87.4189Z"
                        fill="#CDE1FA"/>
                    <path d="M94.9204 91.9819H99.4204V98.5818H94.9204V91.9819Z" fill="#CDE1FA"/>
                    <path
                        d="M62.4002 88C64.6093 88 66.4002 86.2092 66.4002 84C66.4002 81.7909 64.6093 80 62.4002 80C60.1911 80 58.4002 81.7909 58.4002 84C58.4002 86.2092 60.1911 88 62.4002 88Z"
                        fill="#2466B6"/>
                    <path
                        d="M61.6002 84C61.6002 87.344 58.6082 90.272 54.0002 91.456C53.3407 91.6192 52.6731 91.7474 52.0002 91.84C51.4702 91.9204 50.9359 91.9685 50.4002 91.984C50.1282 92 49.8722 92 49.6002 92C39.1522 92 37.6002 86.992 37.6002 84C37.6002 81.008 39.1522 76 49.6002 76C49.8722 76 50.1282 76 50.4002 76.016V79.232C50.1344 79.2051 49.8672 79.1944 49.6002 79.2C43.7602 79.2 40.8002 80.816 40.8002 84C40.8002 87.184 43.7602 88.8 49.6002 88.8C49.8672 88.8056 50.1344 88.7949 50.4002 88.768C50.9372 88.7507 51.4722 88.6918 52.0002 88.592C52.4062 88.546 52.8076 88.4657 53.2002 88.352C56.3042 87.568 58.4002 85.808 58.4002 84C58.4002 83.5756 58.5687 83.1687 58.8688 82.8686C59.1688 82.5686 59.5758 82.4 60.0002 82.4C60.4245 82.4 60.8315 82.5686 61.1315 82.8686C61.4316 83.1687 61.6002 83.5756 61.6002 84Z"
                        fill="#2C73C9"/>
                </svg>
                <div className="welcome-message">
                    For a more accurate home value estimate, please answer a few quick questions.
                </div>
                <button type="button" className="btn btn-default start-flow-button" onClick={this.props.onNext}>
                    Get Started
                </button>
            </div>
        );
    }
}

class ExpectedListDateStep extends Component {
    static get propTypes() {
        return {
            onNext: PropTypes.func
        };
    }

    answers = [
        ['Right Away', _ => new Date().getTime() + 15 * (24 * 60 * 60 * 1000)],
        ['1-3 Months', _ => new Date().getTime() + 30 * (24 * 60 * 60 * 1000)],
        ['4+ Months', _ => new Date().getTime() + 90 * (24 * 60 * 60 * 1000)],
        ['Already Listed', _ => new Date().getTime() - 15 * (24 * 60 * 60 * 1000)]
    ];

    componentDidMount() {
        trackEvent('HomeValue', 'sellerViewedEstimateExpectedListDate').withGA();
    }

    renderAnswer(displayValue, value) {
        return (
            <li key={displayValue}>
                <a href="#" onClick={event => {
                    event.preventDefault();
                    this.props.onNext && this.props.onNext(value);
                }}>
                    {displayValue}
                </a>
            </li>
        );
    }

    render() {
        return (
            <div className="step">
                <div className="step-title">
                    How soon are you looking to sell?
                </div>
                <div className="step-content">
                    <ul className="answers">
                        {this.answers.map(([displayValue, convertValue]) => {
                            return this.renderAnswer(displayValue, convertValue(displayValue));
                        })}
                    </ul>
                </div>
            </div>
        );
    }
}

class HomeTypeStep extends Component {
    static get propTypes() {
        return {
            onNext: PropTypes.func
        };
    }

    static get supportedHomeTypes() {
        return [
            ['Single Family'],
            ['Townhouse'],
            ['Multi-Family'],
            ['Condominium'],
            ['Land'],
            ['Commercial']
        ];
    }

    answers = [
        ['Single Family', 'Single Family'],
        ['Townhouse', 'Townhouse'],
        ['Multi-Family', 'Multi-Family'],
        ['Condominium', 'Condominium'],
        ['Vacant Lot/Other', 'Land'],
        ['Commercial', 'Commercial']
    ];

    componentDidMount() {
        trackEvent('HomeValue', 'sellerViewedEstimateHomeType').withGA();
    }

    renderAnswer(displayValue, value) {
        return (
            <li key={displayValue}>
                <a href="#" onClick={event => {
                    event.preventDefault();
                    this.props.onNext && this.props.onNext(value);
                }}>
                    {displayValue}
                </a>
            </li>
        );
    }

    render() {
        return (
            <div className="step">
                <div className="step-title">
                    What type of property is this?
                </div>
                <div className="step-content">
                    <ul className="answers two-columns">
                        {this.answers.map(([displayValue, value]) => this.renderAnswer(displayValue, value))}
                    </ul>
                </div>
            </div>
        );
    }
}

class PriceRangeStep extends Component {
    static get propTypes() {
        return {
            priceRanges: PropTypes.array,
            onNext: PropTypes.func
        };
    }

    priceRanges = [...this.props.priceRanges].reverse();

    componentDidMount() {
        trackEvent('HomeValue', 'sellerViewedEstimatePriceRange').withGA();
    }

    renderAnswer(priceRange) {
        return (
            <li key={priceRange.rangeStr}>
                <a href="#" onClick={event => {
                    event.preventDefault();
                    this.props.onNext && this.props.onNext(priceRange);
                }}>
                    {priceRange.rangeStr}
                </a>
            </li>
        );
    }

    render() {
        return (
            <div className="step">
                <div className="step-title">
                    How much do you think your home will sell for?
                </div>
                <div className="step-content">
                    <ul className="answers two-columns">
                        {this.priceRanges.map(priceRange => this.renderAnswer(priceRange))}
                    </ul>
                </div>
            </div>
        );
    }
}

class ContactFormStep extends Component {
    static get propTypes() {
        return {
            name: PropTypes.string,
            email: PropTypes.string,
            phone: PropTypes.string,
            onSubmit: PropTypes.func
        };
    }

    formRef = React.createRef();

    state = {
        name: this.props.name,
        email: this.props.email,
        phone: this.props.phone,
        errors: {}
    };

    componentDidMount() {
        trackEvent('HomeValue', 'sellerViewedEstimateContactForm').withGA();

        this.validator = $(this.formRef.current).validate({
            showErrors: () => {
                const errors = {...this.validator.errorMap};
                if (this.validator.invalid) {
                    for (const name of Object.keys(this.validator.invalid)) {
                        errors[name] = errors[name] || '';
                    }
                }
                this.setState({
                    errors
                });
            },
            submitHandler: () => {
                this.props.onSubmit && this.props.onSubmit({
                    name: this.state.name.trim(),
                    email: this.state.email.trim(),
                    phone: this.state.phone
                });
            }
        });
    }

    validateForm() {
        // this.validator.checkForm();
    }

    handleNameInput = event => {
        this.setState({name: event.target.value});
    };

    handleEmailInput = event => {
        this.setState({email: event.target.value});
    };

    handlePhoneInput = event => {
        this.setState({phone: returnNumbersOnly(event.target.value)});
    };

    renderNameIcon = () => <i className="icon icon-profile-outline"/>;

    renderEmailIcon = () => <i className="icon icon-contact-email-outline"/>;

    renderPhoneIcon = () => <i className="icon icon-contact-phone-outline"/>;

    render() {
        return (
            <div className="step">
                <div className="step-title">
                    Where should we send your estimate?
                </div>
                <div className="step-content">
                    <form ref={this.formRef} className="contact-form">
                        <div className="contact-field">
                            <FloatLabelInput
                                type="text"
                                name="name"
                                inputId="hveRequestContactName"
                                inputClass="form-control contact-input"
                                required
                                checkMarkEnabled
                                minwords="2"
                                minLength="5"
                                maxLength="100"
                                autoComplete="name"
                                label="First and last name"
                                errorLabel={this.state.errors.name}
                                renderIcon={this.renderNameIcon}
                                value={this.state.name}
                                onInput={this.handleNameInput}
                            />
                        </div>
                        <div className="contact-field">
                            <FloatLabelInput
                                type="email"
                                name="email"
                                inputId="hveRequestContactEmail"
                                inputClass="form-control contact-input email"
                                required
                                checkMarkEnabled
                                autoComplete="email"
                                autoCorrect="off"
                                autoCapitalize="off"
                                label="Email"
                                errorLabel={this.state.errors.email}
                                renderIcon={this.renderEmailIcon}
                                value={this.state.email}
                                onInput={this.handleEmailInput}
                            />
                        </div>
                        <div className="contact-field">
                            <FloatLabelInput
                                type="tel"
                                name="phone"
                                inputId="hveRequestContactPhone"
                                inputClass="form-control contact-input phoneUS required"
                                checkMarkEnabled
                                maxLength="14"
                                autoComplete="tel"
                                label="Phone"
                                errorLabel={this.state.errors.phone}
                                renderIcon={this.renderPhoneIcon}
                                value={returnPhoneFormat(this.state.phone)}
                                onInput={this.handlePhoneInput}
                            />
                        </div>
                        <button type="submit" className="btn btn-default submit-button">Submit</button>
                    </form>
                </div>
            </div>
        );
    }
}

export default class HVERequestForm extends Component {
    static get propTypes() {
        return {
            address: PropTypes.string,
            homeType: PropTypes.string,
            estimateRange: PropTypes.object,
            priceRanges: PropTypes.array,
            name: PropTypes.string,
            email: PropTypes.string,
            phone: PropTypes.string,
            onFinish: PropTypes.func
        };
    }

    requestData = {
        expectedListDate: null,
        homeType: this.props.homeType,
        name: null,
        email: null,
        phone: null,
        lowRange: (this.props.estimateRange || {}).low,
        highRange: (this.props.estimateRange || {}).high
    };

    state = {
        currentStep: 'welcome',
        isLoading: false
    };

    steps = [
        {
            name: 'welcome',
            render: () => {
                return (
                    <WelcomeStep
                        onNext={() => this.setState({currentStep: this.getNextStep()})}
                    />
                );
            }
        },
        {
            name: 'expectedListDate',
            render: () => {
                return (
                    <ExpectedListDateStep
                        onNext={value => {
                            this.requestData.expectedListDate = value;
                            this.setState({currentStep: this.getNextStep()});
                        }}
                    />
                );
            }
        },
        {
            name: 'homeType',
            shouldSkip: () => {
                return !!this.requestData.homeType
                    && HomeTypeStep.supportedHomeTypes.includes(this.requestData.homeType);
            },
            render: () => {
                return (
                    <HomeTypeStep
                        onNext={value => {
                            this.requestData.homeType = value;
                            this.setState({currentStep: this.getNextStep()});
                        }}
                    />
                );
            }
        },
        // {
        //     name: 'priceRange',
        //     shouldSkip: () => !!this.requestData.lowRange && !!this.requestData.highRange,
        //     render: () => {
        //         return (
        //             <PriceRangeStep
        //                 priceRanges={this.props.priceRanges}
        //                 onNext={priceRange => {
        //                     this.requestData.lowRange = priceRange.low;
        //                     this.requestData.highRange = priceRange.high;
        //                     this.setState({currentStep: this.getNextStep()});
        //                 }}
        //             />
        //         );
        //     }
        // },
        {
            name: 'contactForm',
            render: () => {
                return (
                    <ContactFormStep
                        name={this.props.name}
                        email={this.props.email}
                        phone={this.props.phone}
                        onSubmit={({name, email, phone}) => {
                            this.requestData = {...this.requestData, name, email, phone};
                            this.submitRequest();
                        }}
                    />
                );
            }
        }
    ];

    getNextStep() {
        const currentStep = this.state.currentStep;
        const currentStepIndex = this.steps.findIndex(s => s.name == currentStep);
        for (let i = currentStepIndex + 1; i < this.steps.length; i++) {
            const shouldSkip = this.steps[i].shouldSkip || (() => false);
            if (!shouldSkip()) {
                return this.steps[i].name;
            }
        }
    }

    renderStep(step) {
        return this.steps.find(s => s.name == step).render();
    }

    submitRequest() {
        this.setState({isLoading: true});

        $.post('api/submitRequestDirect-json', {
            tag: window.location.pathname,
            name: this.requestData.name,
            email: this.requestData.email,
            phone: this.requestData.phone,
            expectedListDate: this.requestData.expectedListDate,
            'prop.homeType': this.requestData.homeType,
            'prop.address': this.props.address,
            lowRange: this.requestData.lowRange,
            highRange: this.requestData.highRange
        }).then(data => {
            this.props.onFinish && this.props.onFinish({...data, ...data.req});
        }).always(() => {
            this.setState({isLoading: false});
        });
    }

    render() {
        const {currentStep, isLoading} = this.state;

        return (
            <div className="hve-request-form">
                {this.renderStep(currentStep)}
                {isLoading &&
                    <div className="loadingSpinner" style="display: block; margin: 0">
                        <img alt="spinner" src={global.imageBaseUrl + 'spinner.gif'}/>
                    </div>
                }
            </div>
        );
    }
}
